/* global theme */

export default class PinManagement {
  constructor() {
    this.enteredPinsArray = [];
    this.pinEntryGroupCount = 1;
    this.winningPinsArray = [];
    this.pinsInCart = [];
  }

  updateEnteredPinsArray() {
    var _this = this;
    var selectors = {
      pinEntryField: '.pin-entry-field',
    };

    // reset array
    this.enteredPinsArray = [];

    // update $pinEntryField so that indexing is correct
    var $pinEntryField = theme.jQuery(selectors.pinEntryField);

    $pinEntryField.each(function () {
      var pin = theme.jQuery(this).val();

      if (!!pin) {
        _this.enteredPinsArray.push(pin.toUpperCase());
      } else {
        // remove blank spaces
        theme.jQuery(this).parent().remove();

        // decrement state
        _this.pinEntryGroupCount = _this.pinEntryGroupCount - 1;
      }
    });
  }

  getPinsInCart() {
    var deferred = theme.jQuery.Deferred(),
      _this = this;

    // reset
    this.pinsInCart = [];

    theme.cart.getCart().then(
      function (cart) {
        var cartItems = cart.items;

        for (var i = 0; i < cartItems.length; i++) {
          var cartItem = cartItems[i];
          if (!!cartItem.properties && !!cartItem.properties.pin) {
            _this.pinsInCart.push(cartItem.properties.pin);
          }
        }

        deferred.resolve(this.pinsInCart);
      }.bind(this)
    );

    return deferred;
  }
}
